<div mat-dialog-title class="ds">
  <span>{{ appStrings.paymentDetails_attachments }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon id="closeButton" class="close-icon">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="content ds" [ngClass]="{'mobile': isMobile}" (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  @if (loading.filesLoading || loading.delete) {
    <div class="loading center">
      <ds-progress-spinner id="loading" progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }
  @if (!loading.filesLoading && !loading.delete) {
    <div>
      @if (fileList && fileList.length === 0) {
        <div class="empty-state">
          <ds-icon icon="cloud_upload"></ds-icon>
          <typography variant="mat-body-1" weight="medium">{{ appStrings.paymentDetails_dragDropFiles }}</typography>
          <typography variant="mat-caption-2" weight="regular">{{ appStrings.paymentDetails_orClickAddFiles }}</typography>
        </div>
      }
      @for (file of fileList; track file; let i = $index) {
        <div>
          <div class="file-container">
            <div class="row" [ngClass]="{'inline': !isMobile}">
              <div class="column" [ngClass]="{'three-forths': isMobile}">
                <typography id="fileNameLabel" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.paymentDetails_fileName }} </typography>
                <typography id="fileName_name" class="info" variant="mat-body-1" weight="medium"> {{ file.fileName}} </typography>
              </div>
              <div class="column" [ngClass]="{'one-forth': isMobile}">
                <typography id="fileSizeLabel" class="label" variant="mat-caption-2" weight="regular"> {{ appStrings.paymentDetails_fileSize }} </typography>
                <typography id="fileSize_name" class="info" variant="mat-body-1" weight="medium"> {{ file.fileSize/kb | number:'1.0-0'}} KB </typography>
              </div>
            </div>
            <div class="actions-container">
              @if (!isReadOnly) {
                <ds-button id="deleteButton" [ngClass]="{'spaced-top-btn': !isMobile}" variant="label-icon" icon="delete" size="medium"
                  type="secondary" (click)="deleteFile(file.id, i)" [label]="appStrings.button_delete" iconStyle="material-icons-outlined">
                </ds-button>
              }
              <ds-button id="downloadButton" [ngClass]="{'spaced-top-btn': !isMobile}" variant="label-icon" icon="download" size="medium"
                type="secondary" (click)="downloadFile(file.id, file.fileName)" [label]="appStrings.button_download" iconStyle="material-icons-outlined">
              </ds-button>
            </div>
          </div>
          <ds-divider></ds-divider>
        </div>
      }
    </div>
  }
</div>
<div id="dialog-actions" mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    <ds-button id="closeButton" variant="label-only" size="medium" type="secondary" (onClick)="close()"
      [label]="appStrings.button_close">
    </ds-button>
    <input #fileInput id="uploadFileButton" type="file" (change)="fileChange($event.target.files)" placeholder="Upload file"
      name="uploadFileButton" class="hidden" [attr.disabled]="isReadOnly">
    <ds-button id="addButton" variant="label-only" size="medium" type="primary"
      [label]="appStrings.paymentDetails_addFiles" [isDisabled]="isReadOnly || loading.filesLoading || loading.delete" (click)="fileInput.click()">
    </ds-button>
  </div>
</div>